import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import PreScreenSurvey from "../components/PreScreenSurvey";
import ServiceRequestForm from "../components/ServiceRequestForm";
import ThankYou from "../components/ThankYou";
import { useLocation } from "react-router-dom";

const RequestService = () => {

    const location = useLocation();

    // const [activeComponent, setActiveComponent] = useState("PreScreenSurvey"); // Default Component


    const queryParams = new URLSearchParams(location.search);
    const tabFromUrl = queryParams.get("tab") || "PreScreenSurvey"; // Default: "Education"

    const [activeComponent, setActiveComponent] = useState(tabFromUrl);

    useEffect(() => {
        setActiveComponent(tabFromUrl);
    }, [location.search]); // Reacts to changes in query parameters

    const sidebarSections = [
        {
            title: "Request Service",
            items: ["Pre Screen Survey", "Programs"],
        },
    ];

    return (
        <div className="flex flex-col h-screen">
            {/* Header */}
            <div className="fixed top-0 left-0 w-full z-50 bg-primary">
                <Header />
            </div>

            {/* Main Layout */}
            <div className="flex flex-1 mt-[72px]">
                {/* Sidebar */}
                <div className="fixed left-0 w-64 bg-white shadow-md h-[calc(100vh-72px)] overflow-y-auto hidden lg:block">
                    <Sidebar />
                </div>

                {/* Main Content - Dynamic Rendering */}
                <main className="flex-1 p-6 bg-gray-100 overflow-y-auto mt-[25px] lg:ml-64">
                <div className="flex items-center justify-center h-full">
    <h1 className="text-4xl font-bold text-gray-700">Coming Soon</h1>
  </div>
                    {/* {activeComponent === "Pre Screen Survey" && (
                        <PreScreenSurvey onSubmit={() => setActiveComponent("ServiceRequestForm")} />
                    )}
                    {activeComponent === "Programs" && (
                        <ServiceRequestForm onSubmit={() => setActiveComponent("ThankYou")} />
                    )}
                    {activeComponent === "ThankYou" && (
                        <ThankYou
                            title="Thank you!"
                            message="Your request has been submitted successfully."
                            redirectTo="/explore"
                        />
                    )} */}
                </main>
            </div>
        </div>
    );
};

export default RequestService;
